import React, { useState, useEffect, useRef, memo } from "react";
import { Grid, ToggleButton, ToggleButtonGroup } from "@mui/material";
import organizationService from "services/organizationService";
import { getFormateDate } from "utils/UtilityFunction";
import { CSVLink } from "react-csv";
import * as XLSX from "xlsx";
import JsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Card } from "components/Card";
import Label from "components/Label/Label";
import Dropdown from "components/Dropdown";
import CurrentFilter from "components/CurrentFilter";
import InputComponent from "components/InputComponent";
import DateRangePickerComponent from "components/DateRangePickerComponent";
import { OrganizationTable } from "components/Tables";
import AlertComponent from "components/AlertComponent";

const EXPORT_FIELDS = [
  "id",
  "title",
  "email",
  "organization_type",
  "is_active",
  "is_blocked",
  "sub_domain",
  "created_at",
];

const formatRow = (org) =>
  EXPORT_FIELDS.reduce((acc, key) => {
    acc[key] = org[key] ?? "";
    return acc;
  }, {});

function OrganizationExport() {
  const [allOrganization, setAllOrganization] = useState(null);
  const [exportOrganization, setExportOrganization] = useState([]);
  const [exportFormat, setExportFormat] = useState("csv");
  const [sortBy, setSortBy] = useState(0);
  const [searchItemArray, setSearchItemArrays] = useState([]);
  const [searchInputField, setSearchInputField] = useState("");
  const [searchTitleData, setSearchTitleData] = useState([]);
  const [datePickerValue, setdatePickerValue] = useState(null);
  const [multipleselectData, setMultipleSelectData] = useState([]);
  const [alertState, setAlertState] = useState({
    multipleSlectedAlertError: false,
    alertStatename: "",
    mesage: "",
    varient: "",
  });
  const openAlertModel = (statename, message, variant, alertstateName) => {
    setAlertState((prev) => ({
      ...prev,
      [statename]: true,
      mesage: message,
      varient: variant,
      alertStatename: alertstateName,
    }));
  };
  const closeAlertModel = (statename) => {
    setAlertState((prev) => ({
      ...prev,
      [statename]: false,
    }));
  };
  const csvLink = useRef(null);
  const isFirstRender = useRef(true);

  const divideDatePickerDate = (date) => {
    const dates = new Date();
    const todayDate = getFormateDate(dates);

    if (date) {
      const startDate = getFormateDate(date[0]);
      const endDate = getFormateDate(date[1]);
      return { startDate, endDate };
    }
    return { startDate: todayDate, endDate: todayDate };
  };

  const downloadExcel = (data) => {
    const rows = data.map(formatRow);
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Organizations");
    XLSX.writeFile(wb, "organizations.xlsx");
  };

  const downloadPDF = (data) => {
    const doc = new JsPDF();
    doc.setFontSize(14);
    doc.text("Organizations Export", 14, 15);
    const rows = data.map((org) => EXPORT_FIELDS.map((key) => org[key] ?? ""));
    autoTable(doc, {
      head: [EXPORT_FIELDS],
      body: rows,
      startY: 22,
      styles: { fontSize: 7, cellPadding: 2 },
      headStyles: { fillColor: [30, 74, 115] },
    });
    doc.save("organizations.pdf");
  };

  const exportData = () => {
    const todayDate = new Date();
    let StartDate = "";
    let EndDate = "";
    if (datePickerValue) {
      // eslint-disable-next-line prefer-const
      let { startDate, endDate } = divideDatePickerDate(datePickerValue);
      if (endDate == null) {
        endDate = startDate;
      }
      if (startDate != null) {
        StartDate = startDate;
        EndDate = endDate;
      }
    } else {
      StartDate = getFormateDate(todayDate);
      EndDate = getFormateDate(todayDate);
    }

    let multipleSelectArray = [];
    multipleselectData.forEach((item) => {
      multipleSelectArray = [...multipleSelectArray, { id: item.id }];
    });
    let filterTitles = "";
    multipleSelectArray.forEach((data) => {
      if (filterTitles === "") {
        filterTitles = `${data.id}`;
      } else {
        filterTitles = `${filterTitles},${data.id}`;
      }
    });

    if (multipleselectData.length === 0) {
      openAlertModel(
        "multipleSlectedAlertError",
        "Please select organization ! ",
        "error",
        "multipleSlectedAlertError"
      );
      return;
    }
    organizationService
      .exportData(StartDate, EndDate, sortBy, filterTitles)
      .then((res) => {
        if (res.status === 200) {
          if (exportFormat === "xlsx") {
            downloadExcel(res.data);
          } else if (exportFormat === "pdf") {
            downloadPDF(res.data);
          } else {
            setExportOrganization(res.data);
          }
        }
      });
  };

  const FetchFilterApi = (Filterdata) => {
    organizationService.filterGetOrganizations(Filterdata).then((res) => {
      setAllOrganization(res.data.results);
    });
  };
  const getOrg = () => {
    organizationService.getOrganizations().then((res) => {
      if (res.status === 200) {
        setAllOrganization(res.data.results);
      }
    });
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (exportOrganization.length > 0) {
      csvLink.current.link.click();
    }
  }, [exportOrganization]);

  useEffect(() => {
    if (allOrganization == null) {
      getOrg();
    }
    if (searchInputField) {
      setSearchTitleData([]);
      organizationService
        .handleSearchTitle(searchInputField)
        .then((res) => {
          setSearchTitleData(res.data.results);
        })
        .catch(() => {
          setSearchTitleData([]);
        });
    } else {
      setSearchTitleData([]);
    }
    if (searchItemArray.length > 0) {
      let filterTitles = "";
      searchItemArray.forEach((data) => {
        if (filterTitles === "") {
          filterTitles = `${data.item.title}`;
        } else {
          filterTitles = `${filterTitles},${data.item.title}`;
        }
      });
      const { startDate, endDate } = divideDatePickerDate(datePickerValue);
      const Filterdata = {
        startDate,
        endDate,
        sortBy,
        filterTitles,
      };
      FetchFilterApi(Filterdata);
    }
  }, [searchInputField, searchItemArray]);

  const handleSortBtnFunction = (e) => {
    setSortBy(e.target.value);
    const { startDate, endDate } = divideDatePickerDate(datePickerValue);
    const Filterdata = {
      startDate,
      endDate,
      sortBy: e.target.value,
      filterTitles: [],
    };
    FetchFilterApi(Filterdata);
  };
  const ClearItemTitleData = (data) => {
    if (data) {
      const afterClear = searchItemArray.filter((items) => {
        return items.item.id !== data.item.id;
      });
      setSearchItemArrays(afterClear);
    } else {
      getOrg();
      setSearchItemArrays([]);
    }
  };
  const handleSerachInputField = (e) => {
    setSearchInputField(e.target.value);
  };
  const handleSearchItemArray = (item) => {
    if (searchItemArray.length > 0) {
      const isExistItem = searchItemArray.some(
        (data) => data.item.id === item.id
      );
      setSearchTitleData([]);
      setSearchInputField("");
      if (!isExistItem) {
        setSearchItemArrays([...searchItemArray, { item }]);
      }
    } else {
      setSearchTitleData([]);
      setSearchInputField("");
      setSearchItemArrays([...searchItemArray, { item }]);
    }
  };

  return (
    <div className="b-listing-container">
      <AlertComponent
        title={alertState.mesage}
        msg={alertState.varient}
        handleCloseAlert={() => closeAlertModel(alertState.alertStatename)}
        openAlert={alertState[alertState.alertStatename]}
      />
      <CSVLink
        data={exportOrganization}
        filename="organizations.csv"
        ref={csvLink}
        target="_blank"
      />
      <Grid container spacing={1}>
        <Grid item xs={12} md={4}>
          <div className="b-filter-container-export">
            {/* Export Card */}
            <Card
              title="Export Data"
              bodyStyle="b-organization-container__headingBody"
              isLocked="false"
              body={
                <>
                  <Label label="Export Format" />
                  <ToggleButtonGroup
                    value={exportFormat}
                    exclusive
                    onChange={(_, val) => val && setExportFormat(val)}
                    size="small"
                    style={{ marginBottom: "12px" }}
                  >
                    <ToggleButton value="csv">CSV</ToggleButton>
                    <ToggleButton value="xlsx">Excel</ToggleButton>
                    <ToggleButton value="pdf">PDF</ToggleButton>
                  </ToggleButtonGroup>
                  <Label label="Date Range" />
                  <DateRangePickerComponent
                    handleExportData={exportData}
                    handleChange={(value) => setdatePickerValue(value)}
                    datePickerValue={datePickerValue}
                  />
                </>
              }
            />
            {/* Filter Card */}
            <Card
              title="Filter"
              bodyStyle="b-organization-container__headingBody"
              isLocked="false"
              body={
                <>
                  <Label label="Sort By" />
                  <Dropdown
                    cssName="user-dropdown"
                    setSortBy={handleSortBtnFunction}
                    sortBy={sortBy}
                  />
                  <CurrentFilter
                    filters={searchItemArray}
                    clearDataFun={ClearItemTitleData}
                  />
                  <InputComponent
                    onChange={handleSerachInputField}
                    searchInputField={searchInputField}
                    searchTitleData={searchTitleData}
                    setSearchItemArray={handleSearchItemArray}
                  />
                </>
              }
            />
          </div>
        </Grid>
        <Grid item xs={12} md={8}>
          <div className="b-listing-container__list-section">
            {allOrganization?.length > 0 && (
              <Card
                title="Organizations"
                isLocked="false"
                body={
                  <OrganizationTable
                    organization={allOrganization}
                    isExport
                    setAllOrganization={setAllOrganization}
                    setMultipleSelectData={setMultipleSelectData}
                  />
                }
              />
            )}
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default memo(OrganizationExport);
